export default "__VITE_ASSET__e1e1c622__"